import React from 'react';
import './global.css';

import Routes from './routes';

export default function App() {
  return <Routes />;
}
